module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Axe-65f9b5220808cb14ffcf966f8f887989.svg";